import { render } from "./FailedLoginRegistration.vue?vue&type=template&id=20259348&scoped=true&ts=true"
import script from "./FailedLoginRegistration.vue?vue&type=script&lang=ts"
export * from "./FailedLoginRegistration.vue?vue&type=script&lang=ts"

import "./FailedLoginRegistration.vue?vue&type=style&index=0&id=20259348&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20259348"]])

export default __exports__